async function getUsers(API_BASE, token, code_etablissement, roleAvatars) {
    const headers = {
        "Content-Type": "application/json",
        "Authorization": `Bearer ${token}`,
    };

    const workRes = await fetch(`${API_BASE}/users?code_etablissement=${code_etablissement}`, {
        method: "GET",
        headers,
    });

    if (!workRes.ok) {
        throw new Error("Erreur lectures des Users: " + (await workRes.text()));
    }
    var users = await workRes.json();
    users.forEach(user => {
        user.avatar = roleAvatars[user.role];
    });
    //console.log("Users:", users);


    // On renvoie tout l'ensemble
    return {
        users: users,
    };
}
export default getUsers;